import { render, staticRenderFns } from "./QuanLyNguoiDung.vue?vue&type=template&id=7bb61957&"
import script from "./QuanLyNguoiDung.vue?vue&type=script&lang=js&"
export * from "./QuanLyNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports